import { ProfitabilityStatus } from 'components/profitability/types';

const STATUS_SORT_VALUE: Record<ProfitabilityStatus, number> = {
  [ProfitabilityStatus.CRITICAL]: 0,
  [ProfitabilityStatus.AT_RISK]: 1,
  [ProfitabilityStatus.HEALTHY]: 2,
};

export function statusSortValue(status: ProfitabilityStatus): number {
  return STATUS_SORT_VALUE[status];
}

export function statusLabelId(status: ProfitabilityStatus): string {
  return `profitability.drillDown.${status}.title`;
}

const STATUS_CLASSES: Record<ProfitabilityStatus, { dot: string; text: string }> = {
  [ProfitabilityStatus.HEALTHY]: { dot: 'bg-laurel-600', text: 'text-laurel-600' },
  [ProfitabilityStatus.AT_RISK]: { dot: 'bg-sand-500', text: 'text-sand-600' },
  [ProfitabilityStatus.CRITICAL]: { dot: 'bg-coral-500', text: 'text-coral-500' },
};

export function statusColorClass(status: ProfitabilityStatus): { dot: string; text: string } {
  return STATUS_CLASSES[status];
}
